import { InsurancePlan } from 'src/services/interfaces/insurance';

/**
 * Carrier-brand logo for a plan record — name→brand first (Equitable, Guardian,
 * Cigna, …), then a category fallback, then a neutral placeholder.
 *
 * Extracted VERBATIM from `plan-compare/ComparePlan.tsx` (it was a private
 * closure there) so the W2 self-selection cards can reuse the exact same
 * resolution the B2C plan cards use — the module is PURE (no stores, no API),
 * which is the repo's share-vs-copy rule for cross-flow reuse (stated in full
 * in `src/features/w2/selection/components/PlanCardParts.tsx`).
 */
export const getPlanLogo = (plan?: InsurancePlan): string => {
  const name = (plan?.name || plan?.marketingName || '').toLowerCase();
  const category = (plan?.category || '').toLowerCase();
  if (name.includes('equitable')) return '/images/equitablelogo.svg';
  if (name.includes('guardian')) return '/images/guardian-logo.png';
  if (name.includes('cigna')) return '/images/cigna-logo.svg';
  if (name.includes('telehealth')) return '/images/telehealth-logo.png';
  if (name.includes('legalshield')) return '/images/legalshield-logo.png';
  if (category === 'vision') return '/icons/vision-plan.svg';
  if (category === 'dental') return '/images/dental.svg';
  return '/images/placeholder-icn.png';
};
